// extracted by mini-css-extract-plugin
export var chevron = "_3g-d";
export var disabled = "_3g-b";
export var error = "_3g-c";
export var hideBorder = "_3g-1";
export var icon = "_3g-e";
export var input = "_3g-0";
export var open = "_3g-9";
export var placeholder = "_3g-a";
export var regular = "_3g-5";
export var singleRowInput = "_3g-2";
export var singleSelectInput = "_3g-3 _3g-0";
export var small = "_3g-4";
export var spinnerContainer = "_3g-g";
export var tag = "_3g-7";
export var tagsContainer = "_3g-8";
export var tagsInput = "_3g-6 _3g-0";
export var xSmall = "_3g-f";